import ArgumentLabel from '../arguments/ArgumentLabel.jsx';
import ArgumentWrapper from '../arguments/ArgumentWrapper.jsx';
import LexicalInput from '../lexicalInput/LexicalInput.jsx';

const PanelLexicalInput = ({ label, icon, description, valid, helpIconContext, value, onChange, placeholder, disabled, required, dataType, onTimezoneChange, timezone, argTimezone, actions, showActions, useDataTypes, dataSource, labelProps = {}, inputProps = {}, allowSelfOutput = false }) => {
  return (
    <ArgumentWrapper className="simple-arguments">
      <ArgumentLabel className="small-gap" label={label} icon={icon} description={description} valid={valid} helpIconContext={helpIconContext} isRequired={required} {...labelProps} />
      <LexicalInput simpleArguments value={value} onChange={onChange} placeholder={placeholder} disabled={disabled} dataType={dataType} onTimezoneChange={onTimezoneChange} timezone={timezone} argTimezone={argTimezone} actions={actions} showActions={showActions} useDataTypes={useDataTypes} dataSource={dataSource} allowSelfOutput={allowSelfOutput} {...inputProps} />
    </ArgumentWrapper>
  );
};

export default PanelLexicalInput;
